// extracted by mini-css-extract-plugin
export default {"body":"aboutUs_body__m8D6X","bigText":"aboutUs_bigText__2Wm-a","smallText":"aboutUs_smallText__e0hbz"};